module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary p-10"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "acordo"
    }
  }, [_c('inadimplente-acordo', {
    attrs: {
      "pessoaId": _vm.$route.params.inadimplenteId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "agendamento"
    }
  }, [_c('inadimplente-agendamento', {
    attrs: {
      "pessoaId": _vm.$route.params.inadimplenteId
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#acordo",
      "aria-controls": "acordo",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Novo Acordo")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#agendamento",
      "aria-controls": "agendamento",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Agendamento")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58925ef0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cobranca/inadimplentes/inadimplenteDetalhe.vue
// module id = 398
// module chunks = 1